<xemex-page-header
  [title]="'installations.migrationReport.title' | translate"
  [breadcrumbs]="breadcrumbs"
  [withBackground]="false"
></xemex-page-header>

<xemex-page-body>
  @if (store.summaryError()) {
    <div class="flex items-center justify-between gap-4 mb-6">
      <span>{{ 'installations.migrationReport.summaryFailed' | translate }}</span>
      <xemex-text-button icon="refresh" (click)="reloadSummary()">
        {{ 'installations.insights.retry' | translate }}
      </xemex-text-button>
    </div>
  } @else {
    <div class="migration-report__summary">
      <xemex-card
        [title]="'installations.migrationReport.summary.bySeverity' | translate"
        [loading]="store.isLoadingSummary()"
      >
        <ul class="migration-report__counts">
          @for (severity of severities; track severity) {
            <li class="migration-report__count">
              <span>{{ severityLabel(severity) }}</span>
              <span>{{ store.summary()?.bySeverity?.[severity] ?? 0 }}</span>
            </li>
          }
        </ul>
      </xemex-card>

      <xemex-card
        [title]="'installations.migrationReport.summary.byResolution' | translate"
        [loading]="store.isLoadingSummary()"
      >
        <ul class="migration-report__counts">
          @for (resolution of resolutions; track resolution) {
            <li class="migration-report__count">
              <span>{{ resolutionLabel(resolution) }}</span>
              <span>{{ store.summary()?.byResolution?.[resolution] ?? 0 }}</span>
            </li>
          }
        </ul>
      </xemex-card>

      <xemex-card
        [title]="'installations.migrationReport.summary.byClass' | translate"
        [loading]="store.isLoadingSummary()"
      >
        <ul class="migration-report__counts migration-report__classes">
          @for (entry of classCounts(); track entry.findingClass) {
            <li>
              <button
                type="button"
                class="migration-report__count"
                [class.migration-report__count--selected]="
                  selection().findingClass === entry.findingClass
                "
                [attr.aria-pressed]="selection().findingClass === entry.findingClass"
                (click)="onClassChosen(entry.findingClass)"
              >
                <span>{{ classLabel(entry.findingClass) }}</span>
                <span>{{ entry.count }}</span>
              </button>
            </li>
          }
        </ul>
        <p class="migration-report__note">
          {{ 'installations.migrationReport.summary.classNote' | translate }}
        </p>
      </xemex-card>
    </div>
  }

  @if (store.loadError()) {
    <div class="flex items-center justify-between gap-4 mb-4">
      <span>{{ 'installations.migrationReport.loadFailed' | translate }}</span>
      <xemex-text-button icon="refresh" (click)="reloadPage()">
        {{ 'installations.insights.retry' | translate }}
      </xemex-text-button>
    </div>
  }

  <xemex-table
    [data]="tableData()"
    [columns]="columns"
    [loading]="store.isLoading()"
    [totalCount]="totalCount()"
    [pageSize]="pageSize"
    [clickableRows]="true"
    (rowClick)="openFinding($event)"
    (pageChange)="onPageChange($event)"
  >
    @for (version of [barVersion()]; track version) {
      <xemex-table-filter-bar
        [filterGroups]="filterGroups()"
        [initialFilters]="initialFilters()"
        [showSearch]="false"
        (filterChange)="onFilterChange($event)"
      ></xemex-table-filter-bar>
    }

    <ng-template #actionsCell let-row>
      @if (row.link; as link) {
        <a class="migration-report__link" [routerLink]="link" (click)="$event.stopPropagation()">
          {{ 'installations.migrationReport.table.view' | translate }}
        </a>
      }
    </ng-template>
  </xemex-table>
</xemex-page-body>
